import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import withPopupErrors from '../../../components/HOC/withPopupErrors/withPopupErrors';

import usePagination from '../../../lib/hooks/usePagination';
import { useFilters } from '../../../components/common/Filters/Filters';
import { selectTeachers } from '../../../redux/reducers/TeachersReducer';
import { selectSchools } from '../../../redux/reducers/SchoolsReducer';

import ActionsBar from '../../../components/common/ActionsBar/ActionsBar';
import TeachersFilters from '../../../components/admin/TeachersList/Filters';
import CreateTeacherForm from '../../../components/admin/TeachersList/CreationForm';
import TeachersTable from '../../../components/admin/TeachersList/Table';
import compare from '../../../lib/compare';

import plusIcon from '../../../assets/add.svg';

interface Props {
  showError: (text: string) => void;
  unauthorizedCallback: () => void;
}

const TeachersPage = ({ showError, unauthorizedCallback }: Props) => {
  const [showCreateWindow, setShowCreateWindow] = useState(false);
  const [filters, setFilter] = useFilters({ username: '', school: '' });

  const [sortData, setSortData] = useState({
    column: 'Имя пользователя',
    descending: false,
  });

  const teachers = useSelector(selectTeachers);
  const schools = useSelector(selectSchools);

  const filteredAndSortedTeachers = Object.values(teachers)
    .filter(
      (teacher) =>
        new RegExp(filters.name, 'i').test(teacher.username) &&
        new RegExp(filters.school, 'i').test(
          schools[teacher.schoolId]?.name ?? '',
        ),
    )
    .sort((first, second) => {
      switch (sortData.column) {
        case 'Имя пользователя':
          return compare(first.username, second.username);
        default:
          return compare(
            schools[first.schoolId]?.name ?? '',
            schools[second.schoolId]?.name ?? '',
          );
      }
    });

  if (sortData.descending) filteredAndSortedTeachers.reverse();

  const { paginator, page } = usePagination(
    Math.ceil(filteredAndSortedTeachers.length / 10),
  );

  const teachersForRender = filteredAndSortedTeachers.slice(
    (page - 1) * 10,
    page * 10,
  );

  return (
    <div style={{ display: 'flex', gap: '5rem' }}>
      <div style={{ width: '45vw', minWidth: '20rem' }}>
        <ActionsBar
          actionButtons={[
            {
              src: plusIcon,
              alt: 'Добавить учителя',
              placement: 'right',
              onClick: () => setShowCreateWindow(true),
            },
          ]}
        />

        <TeachersTable
          teachers={teachersForRender}
          schools={schools}
          unauthorizedCallback={unauthorizedCallback}
          showError={showError}
          sortData={sortData}
          setSortData={setSortData}
        />

        {paginator}
      </div>

      <TeachersFilters filters={filters} setFilter={setFilter} />

      {showCreateWindow && (
        <CreateTeacherForm onClose={() => setShowCreateWindow(false)} />
      )}
    </div>
  );
};

export default withPopupErrors<Props>(TeachersPage);
